import { render, staticRenderFns } from "./VehicleRecordModal.vue?vue&type=template&id=3997f0ac"
import script from "./VehicleRecordModal.vue?vue&type=script&lang=js"
export * from "./VehicleRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports